function Contact(){
    return (<div className="container">
        <div className="section contact-info">
            <h2>Get in Touch</h2>
            <p><strong>TriStar Engineers & Services</strong></p>
            <p>UDYAM CERT-UDYAM-UP-01-0031949</p>
            <p>ISO 9001:2015 Certified Company</p>
            <p>(Manufacturer of Online UPS)</p>
            
            <h2>Head Office</h2>
            <p><strong>Address:</strong> D-514, Kalindi Vihar, Agra-282006, Uttar Pradesh</p>
            <p><strong>Phone:</strong> 9557528916, 9559798667</p>
            <p><strong>Email:</strong> tsesagra@gmail.com, sales@tristarengineer.com</p>
            <p><strong>GSTIN:</strong> 09AXJPG1461B1ZU</p>
            <p><strong>State:</strong> 09-Uttar Pradesh</p>
            
            <h2>Branch Office</h2>
            <div style={{ width: "60%", margin: "0 auto", padding: "20px", borderRadius: "8px", color: "white" }}>

                <p><strong><u>Aligarh Branch:</u></strong></p>
                <p>01 Kunjalpur Melrose Byepass, Aligarh</p>
                <p><strong>Phone:</strong> 9045254017</p>
                <hr />

                <p><strong><u>Firozabad Branch:</u></strong></p>
                <p>78/143, Suhag Nagar, Firozabad</p>
                <p><strong>Phone:</strong> 9045254013</p>
                <hr />

                <p><strong><u>Bijnor Branch:</u></strong></p>
                <p>206, Mandi Kotla, Chandpur, Bijnor</p>
                <p><strong>Phone:</strong> 9045254015</p>
                <hr />

                <p><strong><u>Mathura Branch:</u></strong></p>
                <p>P-236 Radha Vintage Goverdhan Rd. Mathura</p>
                <p><strong>Phone:</strong> 9045254016</p>
                <hr />
            </div>
        </div>
    </div>)
}

export default Contact;